import ProductImage from '@assets/png/product.png';

import { ProductRequest } from '@pages/Products/components/AddEquipmentModal/AddEquipmentModal';

import {
  ColumnDiv,
  LinkText,
  ProductDiv,
  ProductHeader,
  ScrollDiv,
} from '@pages/Products/components/AddEquipmentModal/components/SelectBody/components/ListEquipmentsWithMatch/ListEquipmentsWithMatch.styles';

import {
  Button,
  LabelQuantity,
  BlueButton,
} from './ListEquipmentsWithQuantity.styles';
import { Container, Td, Image, Label } from '../../../tables.styles';

interface ListProductsProps {
  dataSelected: ProductRequest[];
  updateDataSelected: (products?: ProductRequest[]) => void;
  returnBody: () => void;
}
const ListEquipmentsWithQuantity = ({
  dataSelected,
  updateDataSelected,
  returnBody,
}: ListProductsProps) => {
  if (!dataSelected) {
    return <div />;
  }
  return (
    <Container>
      <ScrollDiv>
        {dataSelected.map(item => (
          <ProductDiv key={JSON.stringify(item)}>
            <Td width={20}>
              {item.product?.imageUrl ? (
                <Image src={item.product.imageUrl} alt="" />
              ) : (
                <Image src={ProductImage} alt="" />
              )}
              <ColumnDiv>
                <ProductHeader>Model #</ProductHeader>

                {item.product?.model || item.tempProductName}
              </ColumnDiv>
            </Td>
            <Td width={50}>
              <ColumnDiv>
                <ProductHeader>Product Name</ProductHeader>

                {item.product?.name || item.tempProductName}
              </ColumnDiv>
            </Td>

            <Td width={20}>
              <ColumnDiv>
                <ProductHeader>
                  {item.product?.productPage ? 'Product Page' : ''}
                </ProductHeader>
                <LinkText
                  onClick={() => {
                    if (item.product?.productPage)
                      window.open(item.product.productPage, '_blank');
                  }}
                >
                  {item.product?.productPage
                    ? `${
                        item.product.model.length > 0
                          ? item.product.model
                          : 'Product'
                      } Page`
                    : ''}
                </LinkText>
              </ColumnDiv>
            </Td>

            <LinkText
              style={{ color: '#DF6F00', fontWeight: 'normal', cursor: 'auto' }}
            >
              {item.product?.tempProductId ? 'Unmatched' : ''}
            </LinkText>
            <ProductHeader
              style={{ fontSize: 14, marginLeft: 32, marginBottom: 0 }}
            >
              Quantity
            </ProductHeader>
            <Td width={10}>
              <Label>
                <Button
                  disabled={item.quantity === 1}
                  onClick={() => {
                    updateDataSelected([
                      {
                        ...item,
                        quantity: item.quantity - 1,
                      },
                    ]);
                  }}
                >
                  -
                </Button>
                <LabelQuantity>{item.quantity} </LabelQuantity>
                <Button
                  onClick={() => {
                    updateDataSelected([
                      {
                        ...item,
                        quantity: item.quantity + 1,
                      },
                    ]);
                  }}
                >
                  +
                </Button>
              </Label>
            </Td>
          </ProductDiv>
        ))}
        <BlueButton
          onClick={() => {
            returnBody();
          }}
        >
          Add Model
        </BlueButton>
      </ScrollDiv>
    </Container>
  );
};

export { ListEquipmentsWithQuantity };
